import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IDonorProfileHeaderInfo } from '@nkr/models/index';

export interface IDonorProfileHeaderInfoResponse {
    data: {
        success: boolean,
        results: IDonorProfileHeaderInfo
    } 
}

export const ActionCreators = {
    getDonorHeaderInfo: (centerId: number, donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfileHeaderInfoResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/header-info`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}